const nav = require('../utils/nav').Utils;
const auth = require('../utils/auth').Auth;

exports.FavoriteService = {
    getMine: function(callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback(null, JSON.parse(xmlhttp.responseText));
                } else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl('farm/favorite'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    getByURL: function(url, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    let account = null;
                    try {
                        account = JSON.parse(xmlhttp.responseText);
                    } catch (ex) {
                        // ignore
                    }
                    callback(null, account);
                } else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl(`farm/userAccount/${url}`), true);
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    put: function(favorites, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('PUT', auth.getFullUrl('farm/favorite'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(favorites));
    },

    search: function(term, location, distance, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    let pages = [];
                    try {
                        pages = JSON.parse(xmlhttp.responseText);
                    }
                    catch (ex) {
                        // ignore
                    }
                    callback(null, pages)
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                   callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl(`farm/search?location=${encodeURIComponent(location)}&distance=${encodeURIComponent(distance)}&term=${encodeURIComponent(term)}`), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    searchFavorites: function(userID, term, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    let favorites = [];
                    try {
                        favorites = JSON.parse(xmlhttp.responseText);
                    }
                    catch (ex) {
                        // ignore
                    }
                    callback(null, favorites);
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        let url = auth.getFullUrl(userID?`farm/favorite/${userID}/search/${term}`:`farm/favorite/search/${term}`);
        xmlhttp.open('GET', url, true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    delete: function(apID, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('DELETE', auth.getFullUrl(`farm/favorite/${apID}`), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();

    }
}